import { axios } from "../../../../constants/axiosConfig";

// Retornar lista de Cfop
export function getListCfop(filters) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;

  return dispatch => {
    dispatch({
      type: "GET_LIST_CFOP_REQUEST"
    });
    axios
      .get(`cfop/${cnpj}${filters ? filters : ""}`)
      .then(response => {
        dispatch({
          type: "GET_LIST_CFOP_SUCCESS",
          payload: response.data
        });
      })
      .catch(() => dispatch({ type: "GET_LIST_CFOP_FAILURE" }));
    dispatch({ type: "CFOP_CLEAN" });
  };
}

// Editar Cfop
export function putCfop(data) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;

  return dispatch => {
    dispatch({
      type: "PUT_CFOP_REQUEST"
    });
    axios
      .put(`cfop/${cnpj}/${data.Codigo}`, JSON.stringify(data))
      .then(response => {
        dispatch({
          type: "PUT_CFOP_SUCCESS",
          payload: response.data
        });
      })
      .catch(error => dispatch({ type: "PUT_CFOP_FAILURE", payload: error.response.data }));
  };
}
